import React from 'react';
import { CheckCircle2, Target, Eye, Award } from 'lucide-react';

const About = () => {
  return (
    <div className="min-h-screen pt-24 pb-16">
      {/* Hero Section */}
      <section className="py-16 px-4" style={{ background: 'var(--gradient-hero)' }}>
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="heading-1 mb-6">About SEELAKARIYMMAN IRRIGATION</h1>
          <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
            Your trusted partner in modern agriculture and irrigation solutions
          </p>
        </div>
      </section>

      {/* Company Overview */}
      <section className="py-16 px-4" style={{ background: 'var(--bg-page)' }}>
        <div className="max-w-4xl mx-auto">
          <h2 className="heading-2 mb-6 text-center">Who We Are</h2>
          <div className="space-y-6">
            <p className="body-large" style={{ color: 'var(--text-body)' }}>
              SEELAKARIYMMAN IRRIGATION is a trusted agriculture and irrigation solutions provider based in
              Dharmapuri / Nallampalli, Tamil Nadu, India. Founded and led by <strong>Govindaraju K</strong>,
              we have established ourselves as a reliable partner for farmers seeking modern,
              efficient irrigation systems.
            </p>
            <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
              We specialize in providing high-quality drip irrigation systems, pipes, fittings,
              sprinklers, and other irrigation accessories that help farmers optimize water usage,
              increase crop yields, and practice sustainable agriculture.
            </p>
            <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
              Our commitment goes beyond just supplying products. We provide comprehensive support,
              expert installation services, and ongoing technical assistance to ensure our customers
              get the maximum benefit from their irrigation systems.
            </p>
          </div>
        </div>
      </section>

      {/* Mission, Vision, Values */}
      <section className="py-16 px-4" style={{ background: 'var(--bg-section)' }}>
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8">
            {/* Mission */}
            <div className="product-card text-center">
              <div className="flex justify-center mb-4" style={{ color: 'var(--accent-text)' }}>
                <Target className="w-10 h-10" />
              </div>
              <h3 className="heading-3 mb-4">Our Mission</h3>
              <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                To empower farmers with modern irrigation technologies that conserve water,
                increase productivity, and promote sustainable agricultural practices across
                Tamil Nadu.
              </p>
            </div>

            {/* Vision */}
            <div className="product-card text-center">
              <div className="flex justify-center mb-4" style={{ color: 'var(--accent-text)' }}>
                <Eye className="w-10 h-10" />
              </div>
              <h3 className="heading-3 mb-4">Our Vision</h3>
              <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                To become the leading provider of innovative irrigation solutions in the region,
                helping create a future where every farmer has access to efficient water
                management systems.
              </p>
            </div>

            {/* Values */}
            <div className="product-card text-center">
              <div className="flex justify-center mb-4" style={{ color: 'var(--accent-text)' }}>
                <Award className="w-10 h-10" />
              </div>
              <h3 className="heading-3 mb-4">Our Values</h3>
              <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                Quality products, farmer-first approach, honest business practices, technical
                excellence, and commitment to environmental sustainability guide everything we do.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-16 px-4" style={{ background: 'var(--bg-page)' }}>
        <div className="max-w-4xl mx-auto">
          <h2 className="heading-2 mb-8 text-center">Why Choose Seelakari Agro?</h2>
          <div className="space-y-4">
            {[
              'Quality Assurance: We supply only tested and certified irrigation products',
              'Expert Guidance: Professional consultation for system selection and design',
              'Local Expertise: Deep understanding of regional farming needs and conditions',
              'Installation Support: Complete installation services with trained technicians',
              'After-Sales Service: Ongoing technical support and maintenance assistance',
              'Competitive Pricing: Best value for money without compromising on quality',
              'Farmer-Centric Approach: Solutions tailored to individual farm requirements',
              'Government Work: Experienced in handling government agriculture projects'
            ].map((point, index) => (
              <div key={index} className="flex items-start space-x-3">
                <CheckCircle2 className="w-6 h-6 flex-shrink-0 mt-1" style={{ color: 'var(--accent-text)' }} />
                <p className="body-medium" style={{ color: 'var(--text-body)' }}>
                  {point}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Owner Section */}
      <section className="py-16 px-4" style={{ background: 'var(--bg-section)' }}>
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="heading-2 mb-6">Leadership</h2>
          <div className="product-card">
            <h3 className="heading-3 mb-2" style={{ fontSize: '1.5rem' }}>Govindaraju K</h3>
            <p className="body-medium mb-4" style={{ color: 'var(--accent-text)' }}>Founder & Owner</p>
            <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
              With extensive experience in agriculture and irrigation, Govindaraju K founded
              SEELAKARIYMMAN IRRIGATION with a vision to help farmers adopt modern, water-efficient
              irrigation systems. His commitment to quality and farmer welfare has made
              SEELAKARIYMMAN IRRIGATION a trusted name in the region.
            </p>
          </div>
        </div>
      </section>

      {/* Location & Service Area */}
      <section className="py-16 px-4" style={{ background: 'var(--bg-page)' }}>
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="heading-2 mb-6">Our Location</h2>
          <p className="body-large mb-4" style={{ color: 'var(--text-body)' }}>
            <strong>Dharmapuri / Nallampalli, Tamil Nadu, India</strong>
          </p>
          <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
            We are strategically located to serve farmers across Dharmapuri district and
            surrounding areas. Our central location allows us to provide prompt service and
            support to our customers.
          </p>
        </div>
      </section>
    </div>
  );
};

export default About;